export default __webpack_public_path__ + "static/media/fifth.29d22e17.jpg";